import config from '../config';

export async function fetchInstallerErrors(backendFetch, includeMutes = false) {
    const url = config.REACT_APP_HOST + "/api/v2/landing-page/errors" + (includeMutes ? "?include_mutes=true" : "");
    const response = await backendFetch(url)
    return await response.json();
}

export async function fetchInstallerCommissioning(backendFetch) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/landing-page/commissioning")
    return await response.json();
}

export async function fetchInstallerInfoStatistics(backendFetch) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/landing-page/infostats")
    return await response.json();
}


export async function fetchUserActivity(backendFetch, count) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/landing-page/useractivity?n=" + count)
    return await response.json();
}

export async function fetchSiteActivity(backendFetch, count) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/landing-page/siteactivity?n=" + count)
    return await response.json();
}

export async function fetchSiteStatistics(backendFetch, count, metric) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/landing-page/sitestats?n=" + count + "&metric=" + metric)
    return await response.json();
}